import { Box, Divider, ListItemButton, Paper, PaperProps, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { forwardRef, MouseEvent } from 'react';
import { useI18n } from '../../../../i18n/I18n';
import { Icons } from '../../../../icons/Icons';

export type KeyCreditsAutocompletePaperProps = PaperProps & {
    showAddCreditsCta?: boolean;
    emptyListArea?: boolean;
    onOpenAiPanel?: (e: MouseEvent) => void;
};

const KeyCreditsAutocompletePaper = forwardRef<HTMLDivElement, KeyCreditsAutocompletePaperProps>(
    function KeyCreditsAutocompletePaper(
        { showAddCreditsCta, emptyListArea = false, onOpenAiPanel, children, sx, ...paperProps },
        ref
    ) {
        const t = useI18n();
        return (
            <Paper
                ref={ref}
                {...paperProps}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    width: '100%',
                    overflow: 'hidden',
                    ...(emptyListArea && {
                        '& .MuiAutocomplete-listbox': { display: 'none' },
                        '& .MuiAutocomplete-noOptions': { display: 'none' }
                    }),
                    ...sx
                }}
            >
                {emptyListArea ? null : children}
                {showAddCreditsCta ? (
                    <Box sx={{ width: '100%' }}>
                        {!emptyListArea ? <Divider sx={{ width: '100%' }} /> : null}
                        <ListItemButton
                            onMouseDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            onClick={onOpenAiPanel}
                            sx={(theme) => ({
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                width: '100%',
                                boxSizing: 'border-box',
                                border: 'none',
                                cursor: 'pointer',
                                textAlign: 'left',
                                px: 1.5,
                                py: 1.25,
                                bgcolor: alpha(theme.palette.primary.main, 0.06),
                                borderRadius: 0,
                                '&:hover': {
                                    bgcolor: alpha(theme.palette.primary.main, 0.1)
                                }
                            })}
                        >
                            <Icons.AutoAwesomeGradient sx={{ fontSize: 18, flexShrink: 0 }} />
                            <Typography variant="body2" noWrap sx={{ color: 'primary.main' }}>
                                {t('shortlist.key.credits.ai.extract.credits')}
                            </Typography>
                        </ListItemButton>
                    </Box>
                ) : null}
            </Paper>
        );
    }
);

export default KeyCreditsAutocompletePaper;
